import { Check } from "lucide-react";
import { cx } from "../cx.js";
import styles from "./Stepper.module.css";

export interface StepperProps {
  steps: Array<{ id: string; label: string }>;
  currentIndex: number;
  /** Zugänglicher Name der Liste, z. B. „Fortschritt“ */
  label: string;
  className?: string;
}

export function Stepper({ steps, currentIndex, label, className }: StepperProps) {
  return (
    <nav aria-label={label} className={cx(styles.stepper, className)}>
      <ol className={styles.list}>
        {steps.map((s, i) => {
          const state = i < currentIndex ? "done" : i === currentIndex ? "current" : "upcoming";
          return (
            <li
              key={s.id}
              className={cx(styles.step, styles[state])}
              aria-current={state === "current" ? "step" : undefined}
            >
              <span className={styles.dot} aria-hidden="true">
                {state === "done" ? <Check size={14} strokeWidth={3} /> : i + 1}
              </span>
              <span className={styles.label}>{s.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
